import { exportAsExcel } from './ExcelExporter';
import { exportAsPDF } from './PDFExporter';
import { exportAsImage } from './ImageExporter';

export function getExportableColumns(columns = []) {
    return columns.filter((col) => col.headerName !== 'ROW_ACTIONS');
}

export function sanitizeExportFilename(filename = 'export') {
    return String(filename).replace(/\.(xlsx|pdf|png|csv)$/i, '');
}

export function createTableExportHandlers({
    columns = [],
    records = [],
    title = 'Report',
    filename = 'export',
    pdfColumns,
    pdfRecords,
    tableElementRef,
}) {
    const exportColumns = getExportableColumns(columns);
    const safeFilename = sanitizeExportFilename(filename);

    const onExcel = () => {
        exportAsExcel(exportColumns, records, safeFilename);
    };

    const onPDF = () => {
        const cols = pdfColumns || exportColumns.map((col) => ({
            header: col.headerName,
            dataKey: col.fieldName,
            align: col.align,
        }));
        const rows = pdfRecords || records;
        exportAsPDF(title, cols, rows, `${safeFilename}.pdf`);
    };

    const onImage = async () => {
        const element = tableElementRef?.current;
        if (!element) {
            throw new Error('Nothing to capture for image export.');
        }
        element.classList.add('is-exporting-image');
        try {
            await exportAsImage(element, `${safeFilename}.png`);
        } finally {
            element.classList.remove('is-exporting-image');
        }
    };

    return { onExcel, onPDF, onImage };
}
